import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: 'input[appFocus]'
})
export class FocusDirective implements OnInit {

  @Input() isFocused: boolean;

  constructor(private hostElement: ElementRef) {}

  /**
   * Set the focus on the element
   */
  ngOnInit() {
    if (true || this.isFocused) {
      this.hostElement.nativeElement.focus();
      setTimeout(() => { this.hostElement.nativeElement.select(); }, 200);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/directives/focus.directive.ts